export enum EnumTranslationTypes {
    LookupSourceType = 'LOOKUPSOURCETYPE',
    LookupContextMode = 'LOOKUPCONTEXTMODE',
    LookupDefaultValue = 'LOOKUPDEFAULTVALUE',
    LookupDefault = 'LOOKUPDEFAULT',
    LifecycleStage = 'CLIENTLIFECYCLESTAGE',
}
